// pico components
import { picoapp } from 'picoapp';
import announcementBar from '../components/announcement-bar';
import collection from '../components/collection';
import fixedARButton from '../components/fixed-AR-button';
import videoModule from '../components/video-module';

const components = {
	announcementBar,
	collection,
	fixedARButton,
	videoModule,
};

export default picoapp(components);
